import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PanelRoutingModule } from './panel-routing.module';
import { PanelComponent } from './panel.component';
import { MaterialModule } from '@app/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RequestsSharedModule } from '../@shared';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@app/@shared';
import { RequestPanelStore } from '../@shared/request-panel/request-panel.store';
import { DigitalSignatureServiceStore } from '../logalty-digital-signature/digital-signature-service/digital-signature-service.store';
import { OperationSearchModule } from '@app/users/operation-search/operation-search.module';

@NgModule({
  declarations: [PanelComponent],
  imports: [
    FlexLayoutModule,
    CommonModule,
    PanelRoutingModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    RequestsSharedModule,
    OperationSearchModule,
  ],
  providers: [RequestPanelStore],
})
export class PanelModule {}
